export default __webpack_public_path__ + "static/media/stage_07@2x.85ac1ef8.png";